import React from 'react'
import { Canvas } from '../Layouts'
import { CacheBuster } from './CacheBuster'
import { hot } from 'react-hot-loader'
import '@fortawesome/fontawesome-free/css/all.min.css'
import 'react-sliding-pane/dist/react-sliding-pane.css'
import './App.css'
import { PersistGate } from 'redux-persist/lib/integration/react'
import { persistor } from '../state'

function RawApp() {

  return (
    <CacheBuster>
      {({ loading, isLatestVersion, refreshCacheAndReload }) => {
        if (loading) return null
        if (!loading && !isLatestVersion) {
          refreshCacheAndReload()
        }
        return (
          <PersistGate loading={null} persistor={persistor}>
            <Canvas />
          </PersistGate>
        )
      }}
    </CacheBuster>
  )
}

const App = hot(module)(RawApp)
export default App
